import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { energyLevelStore } from 'state/listing/energyLevel'
import EnergyLevelForm from './ModalContent/EnergyLevelForm'

const EnergyLevelModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { energyLevelModal, setEnergyLevelModal, energyLevelData } =
    energyLevelStore(store => ({
      energyLevelModal: store.energyLevelModal,
      setEnergyLevelModal: store.setEnergyLevelModal,
      energyLevelData: store.energyLevelData,
    }))
  return (
    <>
      <CustomModal
        openModal={energyLevelModal}
        closeModal={setEnergyLevelModal}
        title={energyLevelData ? 'Edit Item to bring' : 'Add Item to bring'}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText={energyLevelData ? 'Update' : 'Create'}
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <EnergyLevelForm form={form} />
      </CustomModal>
    </>
  )
}

export default EnergyLevelModal
